import { render, staticRenderFns } from "./PersistResponsavelConfigSmsView.vue?vue&type=template&id=20127a92&"
import script from "./PersistResponsavelConfigSmsView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelConfigSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports